import React from 'react';
import PropTypes from 'prop-types';
import { NavigationActions, addNavigationHelpers } from 'react-navigation';
import { resolvePathAndParamsToUri } from "../modules/navigation";

function getAction(router, path, params) {
  const action = router.getActionForPathAndParams(path, params);
  if (action) {
    return action;
  }
  return NavigationActions.navigate({
    params: { path },
    routeName: 'NotFound',
  });
}

export default NavigationAwareView => {
  class NavigationContainer extends React.Component {
    componentDidMount() {
      const { navigation } = this.props;
      document.title = NavigationAwareView.router.getScreenOptions(
        {
          state: {
            ...navigation.state.routes[navigation.state.index],
            ...navigation.state
          }
        }
      ).title;
      window.onpopstate = e => {
        e.preventDefault();
        const action = getAction(
          NavigationAwareView.router,
          window.location.pathname.substr(1)
        );
        if (action) navigation.dispatch(action);
      };
    }
    componentWillUpdate(props) {
      const { state } = props.navigation;
      const {
        path,
        params
      } = NavigationAwareView.router.getPathAndParamsForState(state);

      const resolvedPath = resolvePathAndParamsToUri(path, params);
      const maybeHash = params && params.hash ? `#${params.hash}` : '';
      const uri = `${resolvedPath}${maybeHash}`;
      if (window.location.pathname !== uri) {
        window.history.pushState({}, state.title, uri);
      }
      const navigation = addNavigationHelpers({
        ...props.navigation,
        state: state.routes[state.index]
      });
      document.title = NavigationAwareView.router.getScreenOptions(
        navigation
      ).title;
    }
    componentDidUpdate() {
      const { params } = NavigationAwareView.router.getPathAndParamsForState(
        this.props.navigation.state
      );
      if (params && params.hash) {
        document.getElementById(params.hash).scrollIntoView();
      }
    }

    render() {
      return (
        <NavigationAwareView
          navigation={this.props.navigation}
        />
      );
    }
    getURIForAction = action => {
      const state = NavigationAwareView.router.getStateForAction(action, this.state) || this.state;
      const { path } = NavigationAwareView.router.getPathAndParamsForState(state);
      return `/${path}`;
    };
    // getActionForPathAndParams = (path, params) => {
    //   return NavigationAwareView.router.getActionForPathAndParams(path, params);
    // };
    static childContextTypes = {
      // getActionForPathAndParams: PropTypes.func.isRequired,
      getURIForAction: PropTypes.func.isRequired,
      // dispatch: PropTypes.func.isRequired,
    };
    getChildContext() {
      return {
        getURIForAction: this.getURIForAction
      };
    }
  }
  return NavigationContainer;
};



// WEBPACK FOOTER //
// ./src/boilerplate/BrowserAppContainer.js